import { RegistryDropdownView } from "./registry-dropdown-view";
import { useRegistryDropdown } from "./use-registry-dropdown";

export const RegistryDropdown = () => {
  const logic = useRegistryDropdown();
  return <RegistryDropdownView {...logic} />;
};
